<div odxLayout="flex gap-small" class="flex-column h-100">
  <odx-area-header class="info-header">
    <h5 class="odx-title-5" i18n="@@checklist.header">Checkliste</h5>
  </odx-area-header>
  <form odxForm [formGroup]="checklistForm" class="form">
    <h6 class="odx-title-6 odx-padding-bottom-16" i18n="@@checklist.header.general">Allgemein</h6>

    <div odxLayout="grid">
      <span odxLayout="12 5@desktop 6@tablet" class="odx-text" i18n="@@checklist.operator.label"
        >Wer ist Betreiber der Anlage?</span
      >
      <odx-form-field
        odxLayout="12 5@desktop 6@tablet"
        [readonly]="(isReadOnlyUser$ | async) === true || (hasWritePermission$ | async) === false"
      >
        <input
          formControlName="operator"
          odxFormFieldControl
          i18n-placeholder="@@checklist.operator.placeholder"
          placeholder="Betreiber der Anlage"
        />
      </odx-form-field>
    </div>
    <div odxLayout="grid">
      <span odxLayout="12 5@desktop 6@tablet" class="odx-text" i18n="@@checklist.client.label">Wer ist Auftraggeber?</span>
      <odx-form-field
        odxLayout="12 5@desktop 6@tablet"
        [readonly]="(isReadOnlyUser$ | async) === true || (hasWritePermission$ | async) === false"
      >
        <input
          formControlName="client"
          odxFormFieldControl
          i18n-placeholder="@@checklist.client.placeholder"
          placeholder="Auftraggeber"
        />
      </odx-form-field>
    </div>

    <app-checklist-item
      i18n-label="@@checklist.switch1.label"
      label="Sind alle Sensoren mit Gasart und Messbereich berücksichtigt?"
      groupName="sensorGasAndMeasurementRangeConsidered"
      [disabled]="!isChecked('sensorGasAndMeasurementRangeConsidered.checked')"
    >
    </app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.switch2.label"
      label="Gibt es Störeinflüsse (Sensorgifte, etc.)?"
      groupName="peturbationsExist"
      [disabled]="!isChecked('peturbationsExist.checked')"
    ></app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.switch3.label"
      label="Sind alle benötigten Relaisausgänge berücksichtigt?"
      groupName="relayOutputsConsidered"
      [disabled]="!isChecked('relayOutputsConsidered.checked')"
    >
    </app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.switch4.label"
      label="Ist die Betriebsspannung der Alarmmittel definiert?"
      groupName="operatingVoltageOfMeansOfAlarmDefined"
      [disabled]="!isChecked('operatingVoltageOfMeansOfAlarmDefined.checked')"
    >
    </app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.switch5.label"
      label="Sind alle Sensoren / Gaswarnzentrale / Alarmmittel positioniert?"
      groupName="sensorsGasAlarmDeviceAndMeansOfAlarmSet"
      [disabled]="!isChecked('sensorsGasAlarmDeviceAndMeansOfAlarmSet.checked')"
    >
    </app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.switch6.label"
      label="Anforderungen Installation / Montage"
      groupName="installationRequirementsDefined"
      [disabled]="!isChecked('installationRequirementsDefined.checked')"
    >
    </app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.switch7.label"
      label="Gibt es Werksnormen / besondere Auflagen?"
      groupName="specialStandardsExist"
      [disabled]="!isChecked('specialStandardsExist.checked')"
    ></app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.switch8.label"
      label="Werden Steiger / Gerüste benötigt / bereitgestellt?"
      groupName="scaffoldingRequired"
      [disabled]="!isChecked('scaffoldingRequired.checked')"
    >
    </app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.switch9.label"
      label="Gibt es Ex-Zonen?"
      groupName="exZonesExist"
      [disabled]="!isChecked('exZonesExist.checked')"
    ></app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.switch10.label"
      label="Freimessung notwendig? Wenn ja, durch wen?"
      groupName="clearanceMeasurementRequired"
      [disabled]="!isChecked('clearanceMeasurementRequired.checked')"
    >
    </app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.switch11.label"
      label="Ist ein Erdungskonzept vorhanden?"
      groupName="electricalGroundingConceptExists"
      [disabled]="!isChecked('electricalGroundingConceptExists.checked')"
    >
    </app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.switch12.label"
      label="Ist eine Be-/Entlüftung vorhanden?"
      groupName="ventilationExists"
      [disabled]="!isChecked('ventilationExists.checked')"
    ></app-checklist-item>

    <div odxLayout="grid">
      <span odxLayout="12 5@desktop 6@tablet" class="odx-text" i18n="@@checklist.personToInstruct.label"
        >Wer ist bei der IBN zugegen, bzw. wer soll eingewiesen werden?</span
      >
      <odx-form-field
        odxLayout="12 5@desktop 6@tablet"
        [readonly]="(isReadOnlyUser$ | async) === true || (hasWritePermission$ | async) === false"
      >
        <input
          formControlName="personToInstruct"
          odxFormFieldControl
          i18n-placeholder="@@checklist.personToInstruct.placeholder"
          placeholder="Einzuweisende Person"
        />
      </odx-form-field>
    </div>

    <hr />
    <h6 class="odx-title-6 headline-padding" i18n="@@checklist.header.installationInstructions">Installationsanweisungen</h6>
    <app-checklist-item
      i18n-label="@@checklist.cableType.label"
      label="Kabeltyp?"
      groupName="cableType"
      [disabled]="!isChecked('cableType.checked')"
    ></app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.sil.label"
      label="SIL?"
      groupName="sil"
      [disabled]="!isChecked('sil.checked')"
    ></app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.workingHeight.label"
      label="Arbeitshöhe?"
      groupName="workingHeight"
      [disabled]="!isChecked('workingHeight.checked')"
    ></app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.deliverySpecifics.label"
      label="Angaben zur Lieferung?"
      groupName="deliverySpecifics"
      [disabled]="!isChecked('deliverySpecifics.checked')"
    ></app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.otherSpecifics.label"
      label="Weitere Angaben?"
      groupName="otherSpecifics"
      [disabled]="!isChecked('otherSpecifics.checked')"
    ></app-checklist-item>

    <hr />
    <h6 class="odx-title-6 headline-padding" i18n="@@checklist.header.serviceInstructions">Wartungsanweisungen</h6>
    <app-checklist-item
      i18n-label="@@checklist.calibrationGas.label"
      label="Kalibriergas?"
      groupName="calibrationGas"
      [disabled]="!isChecked('calibrationGas.checked')"
    ></app-checklist-item>
    <app-checklist-item
      i18n-label="@@checklist.calibrationInstructions.label"
      label="Kalibrierungsanweisungen?"
      groupName="calibrationInstructions"
      [disabled]="!isChecked('calibrationInstructions.checked')"
    ></app-checklist-item>

    @if ((isReadOnlyUser$ | async) === false) {
      <hr />
      <h6 class="odx-title-6 headline-padding" i18n="@@checklist.header.riskAssessment">Risikobewertung</h6>
      <app-checklist-item
        i18n-label="@@checklist.deadlineRisks.label"
        label="Deadline-Risiken?"
        groupName="deadlineRisks"
        [disabled]="!isChecked('deadlineRisks.checked')"
      ></app-checklist-item>
      <app-checklist-item
        i18n-label="@@checklist.technicalRisks.label"
        label="Technische Risiken?"
        groupName="technicalRisks"
        [disabled]="!isChecked('technicalRisks.checked')"
      ></app-checklist-item>
      <app-checklist-item
        i18n-label="@@checklist.commercialRisks.label"
        label="Geschäftliche Risiken?"
        groupName="commercialRisks"
        [disabled]="!isChecked('commercialRisks.checked')"
      ></app-checklist-item>
      <app-checklist-item
        i18n-label="@@checklist.otherRisks.label"
        label="Weitere Risiken?"
        groupName="otherRisks"
        [disabled]="!isChecked('otherRisks.checked')"
      ></app-checklist-item>
    }
  </form>
</div>
